import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { reactive } from 'vue';
import UserService from '@/services/user.service';
import Cookies from 'js-cookie';

interface User {
  isLogin: boolean;
  accessToken: string;
  avatar: string;
  bizUserId: string;
  cellphone: string;
  rawCellphone: string;
  isFirstRegister: string;
  mtcUserId: string;
  nickname: string;
  refreshToken: string;
  bizCode?: string;
  joinedDay?: string;
  subBizCode?: string;
  userLevel?: string;
  userLevelId?: string;
  userLevelName?: string;
}
export const useUserStore = defineStore('user', () => {
  const userservice = new UserService();
  const userInfo = reactive<User>({
    isLogin: false,
    accessToken: '',
    avatar: '',
    bizUserId: '',
    cellphone: '',
    rawCellphone: '',
    isFirstRegister: '',
    mtcUserId: '',
    nickname: '',
    refreshToken: '',
  });

  const isLogin = computed(() => userInfo.isLogin);
  const avatar = computed(() => userInfo.avatar);
  const nickname = computed(() => userInfo.nickname);
  const rawCellphone = computed(() => userInfo.rawCellphone);


  const login = (info:User) => {
    Object.assign(userInfo, info);
    userInfo.isLogin = true;
    _setToken2Cookie(userInfo.accessToken);
    userInfo.accessToken = ''; // 存入cookie 后清空local
    userInfo.refreshToken = ''; // 存入cookie 后清空local
    getUserInfo();
  }

  const _setToken2Cookie = (accessToken:string) =>{
    Cookies.set('tq_token', accessToken);
  }

  const getTokenFromCookie = () =>{
    return Cookies.get('tq_token');
  }

  const logout = () => {
    for (const key of Object.keys(userInfo)) {
      const _key = key as keyof User;
      (userInfo[_key] as any) = '';
    }
    Cookies.remove('tq_token');
    userInfo.isLogin = false;
  }

  // 获取个人信息
  const getUserInfo = () => {
    userservice.getUserInfo().then(({ statusCode, data  }) => {
      if (statusCode === 200 && data) {
        userInfo.bizCode = data.bizCode;
        userInfo.joinedDay = data.joinedDay;
        userInfo.subBizCode = data.subBizCode;
        userInfo.userLevel = data.userLevel;
        userInfo.userLevelId = data.userLevelId;
        userInfo.userLevelName = data.userLevelName;
      }
    })
  }

  return {
    isLogin, userInfo, getTokenFromCookie,
    avatar, nickname, rawCellphone,
    login, logout, getUserInfo };
},{ persist: true })
